import { Component } from 'react'
import { trackError } from '../../../services/errorTracking'

class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error, errorInfo) {
    const { page, component } = this.props
    trackError(error, {
      type: 'error_boundary',
      page,
      component,
      extra: { componentStack: errorInfo?.componentStack },
    })
  }

  render() {
    const { hasError } = this.state
    const { children, fallback = null } = this.props

    if (hasError) {
      return fallback
    }

    return children
  }
}

export default ErrorBoundary
